import { render } from "./StepForm6.vue?vue&type=template&id=0b990dd4&scoped=true"
import script from "./StepForm6.vue?vue&type=script&lang=js"
export * from "./StepForm6.vue?vue&type=script&lang=js"

import "./StepForm6.vue?vue&type=style&index=0&id=0b990dd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b990dd4"]])

export default __exports__